/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-var */
import clientConfiguration from "./client-configuration";

let fbLoaded = false;
let gtmLoaded = false;

declare const fbq: any;
const loadFb = () => {
  if (fbLoaded) return;
  (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  fbq("init", "653644375453926");
  fbq("track", "PageView", { hostname: location.hostname });
  fbLoaded = true;
};

interface Window {
  didomiOnReady: Function[];
  didomiEventListeners: any[];
  Didomi: any;
}

const loadGtm = () => {
  if (gtmLoaded) return;

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    const f = d.getElementsByTagName(s)[0],
      j: any = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode!.insertBefore(j, f);
  })(window, document, "script", "dataLayer", clientConfiguration.gtmId);
  gtmLoaded = true;
};

function generateDeferredPromise() {
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    [resolve, reject] = [res, rej];
  });
  return { promise, reject, resolve };
}

const { promise, resolve } = generateDeferredPromise();

export const cookieDecision = promise;

declare const window: Window;

const initDidomi = () => {
  window.didomiEventListeners = window.didomiEventListeners || [];
  window.didomiEventListeners.push(
    {
      event: "preferences.hidden",
      listener: function () {
        resolve();
      },
    },
    {
      event: "notice.hidden",
      listener: function () {
        resolve();
      },
    }
  );

  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    if (Didomi.isConsentRequired()) {
      // Consent is required: your visitor is from the EU or you are an EU company
      // Only enable the vendor when consent is given
      Didomi.getObservableOnUserConsentStatusForVendor("c:facebook-7ytVrMJJ")
        .filter(function (status) {
          return status === true;
        }) // Filter out updates where status is not true
        .first() // Only get the first consent status update
        .subscribe(function (consentStatusForVendor) {
          // The user has given consent to the vendor
          if (consentStatusForVendor) {
            loadFb();
          }
        });
    } else {
      // Consent is not required, enable your vendor immediately
      loadFb();
    }
  });
};

const init = () => {
  loadGtm();
  initDidomi();
};

init();
